var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_header"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,staticClass:"common_header_item",class:{'common_header_select':item.id == _vm.selectId},on:{"click":function($event){return _vm.changeTab(item)}}},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa8ed38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header_tab.vue
// module id = null
// module chunks = 